import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import studentProfileAPI from './services/studentProfileAPI';
import divisionConfigurationAPI from './services/DivisionConfigurationAPI';
import divisionAssignmentAPI from './services/DivisionAssignmentAPI';
import osVersionCompatibilityAPI from './services/osVersionCompatibilityAPI';
import studentNotificationAPI from './services/studentNotificationAPI';
import educationDashboardAPI from './services/educationDashboardAPI';
import studentPromotionAPI from './services/studentPromotionAPI';

import {
  profileAPI,
  menuAPI,
  CommonAPI,
  GovAnnouncementAPI,
  NotificationAPI
} from "@gyandiksha/shared-ui/app/services";
import studentCommonAPI from './services/studentCommonAPI';

const appReducer = (state = {}) => state;

export const store = configureStore({
  reducer: {
    app: appReducer,
    [studentProfileAPI.reducerPath]: studentProfileAPI.reducer,
    [divisionConfigurationAPI.reducerPath]: divisionConfigurationAPI.reducer,
    [divisionAssignmentAPI.reducerPath]: divisionAssignmentAPI.reducer,
    [GovAnnouncementAPI.reducerPath]: GovAnnouncementAPI.reducer,
    [osVersionCompatibilityAPI.reducerPath]: osVersionCompatibilityAPI.reducer,
    [studentNotificationAPI.reducerPath]: studentNotificationAPI.reducer,
    [educationDashboardAPI.reducerPath]: educationDashboardAPI.reducer,
    [studentPromotionAPI.reducerPath]: studentPromotionAPI.reducer,
    [profileAPI.reducerPath]: profileAPI.reducer,
    [CommonAPI.reducerPath]: CommonAPI.reducer,
    [menuAPI.reducerPath]: menuAPI.reducer,
    [NotificationAPI.reducerPath]: NotificationAPI.reducer,
    [studentCommonAPI.reducerPath]: studentCommonAPI.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      studentProfileAPI.middleware,
      divisionConfigurationAPI.middleware,
      divisionAssignmentAPI.middleware,
      GovAnnouncementAPI.middleware,
      osVersionCompatibilityAPI.middleware,
      studentNotificationAPI.middleware,
      educationDashboardAPI.middleware,
      studentPromotionAPI.middleware,
      profileAPI.middleware,
      CommonAPI.middleware,
      menuAPI.middleware,
      NotificationAPI.middleware,
      studentCommonAPI.middleware
    ),
});

setupListeners(store.dispatch);
